var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    { style: { height: "100%" } },
    [
      _c(
        "w-col",
        {
          staticClass: "col",
          attrs: { sm: "12", md: "12", lg: "5", "no-margin": "", center: "" },
        },
        [
          _vm.$wf.isMdDown && _vm.showMobileLogo
            ? _c("div", { staticClass: "logo" })
            : _vm._e(),
          _c("w-scroll-view", { staticClass: "content" }, [
            _c("div", { staticClass: "content-block" }, [_vm._t("default")], 2),
          ]),
        ],
        1
      ),
      !_vm.$wf.isMdDown
        ? _c("app-billboard", {
            attrs: { sm: "12", lg: "7", step: _vm.step, "show-downloads": "" },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }